import { NavLink, useHistory } from "react-router-dom";
import Button from '@mui/material/Button';
import icoMenu from '../../assets/header/menu.svg';
import logoiDream from '../../assets/header/idream-azul.svg';
import icoProfile from '../../assets/header/profile.svg';
import './header.component.scss';
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, SwipeableDrawer } from "@mui/material";
import React, { useEffect } from "react";
import MailIcon from '@mui/icons-material/Mail';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import HomeIcon from '@mui/icons-material/Home';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ChatIcon from '@mui/icons-material/Chat';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LockIcon from '@mui/icons-material/Lock';
import LogoutIcon from '@mui/icons-material/Logout';
import UsuarioModel from "../../models/usuario.model";
import { UsuarioEfetuouLogOutService } from "../../services/usuario-efetuou-login.service";
import { UsuarioEfetuouLoginService } from "../../services/usuario-efetuou-login.service";
import { getAuthUser } from "../../services/auth";
import MenuIcon from '@mui/icons-material/Menu';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import Brightness5Icon from '@mui/icons-material/Brightness5';

function HeaderComponent() {

  const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);
  const [usuarioLogado, setUsuarioLogado] = React.useState<UsuarioModel>(getAuthUser());

  let history = useHistory();

  useEffect(() => {

    UsuarioEfetuouLoginService.getMSG().subscribe((usuarioService: any) => {
      setUsuarioLogado(usuarioService);
    });

    UsuarioEfetuouLogOutService.getMSG().subscribe((usLogout: any) => {
      if (usLogout == true) {
        Sair();
      }
    });

    let usLogado = localStorage.getItem("user");
    if (usLogado) {
      setUsuarioLogado(JSON.parse(usLogado));
    }
  }, []);

  const Sair = () => {
    localStorage.removeItem('user');
    history?.push({
      pathname: '/login'
    })
  }

  const GoPage = (page: string) => {
    history?.push({
      pathname: '/' + page
    })
  }

  return (
    <>
      <header className="flex flex-sp flex-cv">
        <Button className="burger" onClick={() => { setOpenDrawer(true) }}>
          {/* <img src={icoMenu} alt="Menu" /> */}
          <MenuIcon />
        </Button>
        <Button className="bt-logo" onClick={() => { GoPage('') }}>
          <img src={logoiDream} alt="logo iDream" />
          <small>v.1.5</small>
        </Button>
        <Button className="bt-profile" onClick={() => { GoPage('meu-perfil') }}>
          {
            usuarioLogado ?
              usuarioLogado.foto?.toString().indexOf('http') > -1 ?
                <img src={usuarioLogado.foto} alt="Profile" />
                :
                <img src={icoProfile} alt="Profile" />
              :
              <img src={icoProfile} alt="Profile" />
          }
        </Button>
        {/* <nav>
          <ul className="flex flex-sp flex-cv">
            <li>
              <NavLink exact={true} to="/home" activeClassName="active">
                <Button>Home</Button>
              </NavLink>
            </li>
            <li>
              <NavLink exact={true} to="/eventos" activeClassName="active">
                <Button>Eventos</Button>
              </NavLink>
            </li>
          </ul>
        </nav> */}
      </header>
      <SwipeableDrawer
        anchor='left'
        open={openDrawer}
        onClose={() => { setOpenDrawer(false) }}
        onOpen={() => { setOpenDrawer(true) }}
      >
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={() => { setOpenDrawer(false) }}
          onKeyDown={() => { setOpenDrawer(false) }}
        >
          <List>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { GoPage('') }}>
              <HomeIcon /> Home
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { GoPage('sonho') }}>
                <NightsStayIcon /> Sonho
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { GoPage('diario') }}>
                <Brightness5Icon /> Diário
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { GoPage('contato') }}>
                <AlternateEmailIcon /> Contato
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={() => { GoPage('termos-e-condicoes-de-uso') }}>
                <LockIcon /> Termos de uso
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton onClick={Sair}>
                <LogoutIcon /> Sair
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </SwipeableDrawer>
    </>
  );
}

export default HeaderComponent;
